const AMOUNT_CURRENT = 'entity_has';
const AMOUNT_MAX = 'entity_max';
const AMOUNT_MIN = 'entity_min';
const JOB = 'job';

export function shouldLoadOnboarding(requirements) {
    if (!requirements || requirements.length === 0) {
        return false;
    }

    let pendingRequirements = getPendingRequirements(requirements);
    return pendingRequirements.length > 0;
}

export function getPendingRequirements(requirements) {
    if (!requirements || requirements.length === 0) {
        return [];
    }

    return requirements.filter(r => !isRequirementSatisfied(r));
}

export function getPendingJobRequirement(requirements) {
    return requirements.find(r => !isRequirementSatisfied(r) && isJobRequirement(r));
}

function isRequirementSatisfied(requirement) {
    if (!requirement) {
        return true;
    }

    if (isJobRequirement(requirement)) {
        return requirement.field_value === 'active' || requirement.field_value === 'submitted' || requirement.field_value === 'inactive';
    }

    if (isEnumeratedRequirement(requirement)) {
        return requirement[AMOUNT_CURRENT] >= requirement[AMOUNT_MIN];
    }

    return true;
}

function isEnumeratedRequirement(requirement) {
    return requirement.hasOwnProperty(AMOUNT_CURRENT) && requirement.hasOwnProperty(AMOUNT_MAX) && requirement.hasOwnProperty(AMOUNT_MIN);
}

function isJobRequirement(requirement) {
    return requirement.entity === JOB && requirement.field_name === 'status';
}



// WEBPACK FOOTER //
// ./src/utilities/requirements.jsx